module.exports = __webpack_public_path__ + "img/trash-can.3976577b.svg";